import React, { Component } from "react";
import { connect } from "react-redux";

import { getChannels } from "../../store/channels";

import { Grid } from "semantic-ui-react";

import ColorPanel from "../colorPanel";
import SidePanel from "../sidePanel";
import Messages from "../messages";
import MetaPanel from "../metaPanel";

class Home extends Component {
    state = { showMetaPanel: false, loading: true };

    async componentDidMount() {
        await this.props.getChannels();

        this.setState({ loading: false });
    }

    setShowMetaPanel = showMetaPanel => this.setState({ showMetaPanel });

    render() {
        const { showMetaPanel, loading } = this.state;
        const { currentUser, channels, messages } = this.props;

        if (loading) return null;

        return (
            <Grid columns="equal" className="home app" style={{ margin: 0 }}>
                <ColorPanel
                    currentUser={currentUser}
                    channels={channels}
                    showMetaPanel={showMetaPanel}
                    setShowMetaPanel={this.setShowMetaPanel}
                />

                <SidePanel currentUser={currentUser} channels={channels} />

                <Grid.Column className="messages-chat--container">
                    <Messages currentUser={currentUser} channels={channels} messages={messages} />
                </Grid.Column>

                <Grid.Column className={`meta-panel--container ${showMetaPanel ? "show" : ""}`}>
                    <MetaPanel currentUser={currentUser} channels={channels} />
                </Grid.Column>
            </Grid>
        );
    }
}

const mapStateToProps = ({ user: { currentUser }, channels, messages }) => ({ currentUser, channels, messages });

export default connect(mapStateToProps, { getChannels })(Home);

/*
->>: Before We make loading before render

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ColorPanel from "../colorPanel";
import SidePanel from "../sidePanel";
import Messages from "../messages";
import MetaPanel from "../metaPanel";
import { Grid } from "semantic-ui-react";

import { getChannels } from "../../store/channels";

const Home = () => {
    const [showMetaPanel, setShowMetaPanel] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => dispatch(getChannels()), []);

    const appState = useSelector(({ user: { currentUser }, channels, messages }) => ({ currentUser, channels, messages }));

    return (
        <Grid columns="equal" className="home app" style={{ margin: 0 }}>
            <ColorPanel
                currentUser={appState.currentUser}
                channels={appState.channels}
                showMetaPanel={showMetaPanel}
                setShowMetaPanel={setShowMetaPanel}
            />

            <SidePanel currentUser={appState.currentUser} channels={appState.channels} />

            <Grid.Column className="messages-chat--container">
                <Messages currentUser={appState.currentUser} channels={appState.channels} messages={appState.messages} />
            </Grid.Column>

            <Grid.Column className={`meta-panel--container ${showMetaPanel ? "show" : ""}`}>
                <MetaPanel currentUser={appState.currentUser} channels={appState.channels} />
            </Grid.Column>
        </Grid>
    );
};

export default Home;

*/
